export default __webpack_public_path__ + "static/media/search-blue.4e86c7f7.svg";